import { XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Text } from '../../../../../../components/atoms/text/text';
import { RenderSlot } from '../../../../../../utils/render-slot';
import { AnsweredStatus } from '../../../../utils/surveys/conditions';
import { NotShownConditionContentProps, ShownContentProps } from '../types';

import { AnswersBreakdown } from './answers-breakdown';

const NotAdministeredText = () => {
  const { t } = useTranslation();
  return <Text>{t('report.conditionNotAdministered')}</Text>;
};

const NotAnswered = ({
  answeredStatus,
  withIcon = true,
}: {
  readonly answeredStatus: AnsweredStatus;
  readonly withIcon?: boolean;
}) => {
  const { t } = useTranslation();
  if (answeredStatus === AnsweredStatus.COMPLETED) return null;

  const displayText = (() => {
    if (answeredStatus === AnsweredStatus.NOT_COMPLETED) return t('report.questionNotCompleted');
    if (answeredStatus === AnsweredStatus.SKIPPED) return t('report.conditionSkipped');
    return;
  })();

  return (
    <Text className="flex gap-2">
      {withIcon && <XCircle></XCircle>}
      <span>{displayText}</span>
    </Text>
  );
};

const NotShownConditionContent = ({ isSkipped, isNotShown }: NotShownConditionContentProps) => {
  if (isSkipped) return null;
  return isNotShown ? <NotAdministeredText /> : null;
};

const ShownContent = ({
  additionalContent,
  answerBreakdown,
  answerBreakdownKey,
  allRespondents,
  survey,
}: ShownContentProps) => (
  <>
    <Text className="pb-2">{answerBreakdownKey}</Text>
    {answerBreakdown && (
      <AnswersBreakdown allRespondents={allRespondents} answerBreakdown={answerBreakdown} survey={survey} />
    )}
    {additionalContent && <RenderSlot minEmptyHeight={50} slot={additionalContent} />}
  </>
);

export { NotAdministeredText, NotAnswered, NotShownConditionContent, ShownContent };
